<template>
    <div class="grey-bg">
        <div class="row">
            <div class = "header-row">
                <div class="header-cell"></div>
                <div class="header-cell"></div>
                <div class="header-cell"></div>
                <div class="header-cell"></div>
            </div>
        </div>
        <div class="row">
            <div class="timeline-wrapper">
                <div class="timeline-item">
                    <div class="background">
                        <div class="background-masker"></div>
                    </div>
                </div>
                <div class="timeline-item">
                    <div class="background">
                        <div class="background-masker"></div>
                    </div>
                </div>
                <div class="timeline-item">
                    <div class="background">
                        <div class="background-masker"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
      name: 'v-fake-table',
      model: {
        prop: 'itemType',
        event: 'change'
      },
      props: {
        type: {
          type: String,
          default: null
        }
      },
      data () {
        return {}
      },
      created () {
      },
      computed: {},
      methods: {},
      watch: {}

    }
</script>

<style>

    .timeline-item {
        background: #fff;
        border-bottom: 1px solid #f2f2f2;
        padding: 12px;
        margin: 0 auto;
    }

    .background {
        background: #f6f7f8;
        height: 25px;
        position: relative;
    }

    .background-masker {
        background: #fff;
        position: absolute;
    }

    .header-cell
    {
        background: #f6f7f8;
        border-color: white;
        border-width: 8px;
        width:24%;
        height: 25px;
        text-align:left;
        display:inline-block;
    }
    .header-row
    {
        text-align:center;
        width:100%;
        margin: 0 auto;
    }

</style>



// WEBPACK FOOTER //
// src/components/Shared/FakeTable.vue